/**
 * * `contentHTMLParser` removes the outer tag that Rich Mahogany's WYSIWYG library must generate.
 * * It should strip the outer tag regardless if it has attributes or not.
 * * It then returns the outer tag's name and the inner content for use in the WysiwygContent Block.
 * * Regex Explanation Gist => https://gist.github.com/ggrumbley/f8d15ed5822cb380556a8df850f969cf
 * * Regex101 Playground => https://regex101.com/r/QGXRNO/1
 * @param rawHtml
 * @returns string[] containing an outer html tag defaulted to p and innerHtml to handle no tag
 */
export const contentHTMLParser = rawHtml => {
  const regex = /^<([a-z1-6]+)([^>]+)*(?:>(.*)<\/\1>|\s+\/>)$/;
  const regexMatches = regex.exec(rawHtml);
  return regexMatches ? [regexMatches[1], regexMatches[3]] : ['p', rawHtml];
};